import { render, staticRenderFns } from "./SchoolEventSlidebar.vue?vue&type=template&id=24ce09c6"
import script from "./SchoolEventSlidebar.vue?vue&type=script&lang=js"
export * from "./SchoolEventSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports